import cloneDeep from 'lodash/fp/cloneDeep';
import { CreditDataSourceCA } from '@/utils/enums';
import i18n from '@/i18n';

const initialState = {
  payingType: null,
  flowSelected: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  getDefaultCreditDataSourceCAName: (state, getters, rootState, rootGetters) => {
    if (rootGetters['business/getDefaultCreditDataSourceCA'] === CreditDataSourceCA.EQUIFAX) {
      return {
        niceName: i18n.t('message.common.equifax'),
        niceNameV2: i18n.t('message.common.dEquifax'),
        logoName: 'Equifax-Logo.svg',
      };
    }
    // Default to TransUnion for ecom
    return {
      niceName: i18n.t('message.common.transUnion'),
      niceNameV2: i18n.t('message.common.dTransUnion'),
      logoName: 'TransUnion-Logo.svg',
    };
  },
};

const mutations = {
  SET_STATE(state, [key, data]) {
    state[key] = data;
  },
};

const actions = {};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  mutations,
  actions,
  getters,
};
